<template>
  <login-overlay
    v-show="isLoaded"
    v-loading="isSigningIn"
    class="login"
    el-loading-background="fixed-white"
    :el-loading-opacity=".8"
    :el-loading-size="48"
    :el-loading-text="$t('Signing in...')"
    :inverse="false"
  >
    <div class="wrapper">
      <h2 class="header">
        {{ $t('Sign in') }}
      </h2>
      <div
        v-if="showError"
        class="server-errors mb-8 mt-16"
      >
        {{ $t('Login has been disabled by the administrator') }}
      </div>
      <id-p-login
        :button-type="'primary'"
        :domain-name="domainName"
        :idp="idp"
        :auto-login="!isLoggedOut && !showError"
        :session-id="'1'"
      />
    </div>
  </login-overlay>
</template>

<script>
  import LoginOverlay from '@/common/components/user/LoginOverlay.vue';
  import IdPLogin from '@/common/components/user/IdPLogin.vue';
  import LoginPageMixin from '@/common/mixins/loginPage.mixin';
  import useAuthStore from '@/common/store/pinia/auth';
  import { mapStores } from 'pinia';
  import useAppStore from '@/common/store/pinia/app';

  export default {
    name: 'Login',
    components: {
      IdPLogin,
      LoginOverlay
    },
    mixins: [LoginPageMixin],
    props: {
      domainName: String,
      idp: String
    },
    data() {
      return {
        isLoaded: false
      };
    },
    computed: {
      ...mapStores(useAuthStore, useAppStore),
      isLoggedOut() {
        return this.$route.query.logout === 'true';
      },
      showError() {
        return this.$route.query.failed;
      }
    },
    watch: {
      isSigningIn: {
        immediate: true,
        handler(newVal, oldVal) {
          if (newVal && !oldVal) {
            // do not blink with login form on auto-login links
            this.isLoaded = false;
            setTimeout(() => {
              this.isLoaded = true;
            }, 600);
          } else {
            this.isLoaded = true;
          }
        },
      }
    },
    methods: {
      getLandingPage() {
        return this.appStore.fetchSsLandingPage();
      }
    }
  };
</script>
<style lang="scss" scoped>
  .login {
    background: $av-brand-lightest;
  }

  .wrapper {
    box-shadow: $av-box-shadow rgba(0, 0, 0, 0.25);
    width: 512px;
    padding: 24px 24px 32px;
    margin: 0 auto;
    border-radius: 5px;
    background: $av-inversed-primary;

    .header {
      font-size: $av-font-size-l;
      font-weight: $av-font-weight-normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 32px;
      letter-spacing: normal;
      text-align: center;
      color: $av-fixed-primary;
      margin: 0 0 8px;
    }
  }

  .server-errors {
    padding: 24px;
    background: $av-fixed-danger-accent;
    border-radius: $av-border-radius-2;
    text-align: center;
  }
</style>
